'use client';

import { c as _c } from "react/compiler-runtime";
import Swimlane from '@/app/[locale]/(worlds)/components/Swimlane';
import { cn } from '@/lib/utils';
import type { WorldCardLane } from '@/types/viverse-world-card';
type WorldSectionProps = {
  index: number;
  world: WorldCardLane;
};
function WorldSection(t0) {
  const $ = _c(14);
  const {
    index,
    world
  } = t0;
  const title = world.title ?? "";
  let t1;
  if ($[0] !== title) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /\s+/g;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = title.toLowerCase().trim().replace(t2, "-");
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slug = t1;
  const hasNonAscii = [...title].some(_temp);
  const rowKey = slug && !hasNonAscii ? slug : world.id;
  const t2 = String(index + 1);
  let t3;
  if ($[3] !== rowKey || $[4] !== t2 || $[5] !== title || $[6] !== world.id) {
    t3 = {
      "data-ph-capture-attribute-row-index": t2,
      "data-ph-capture-attribute-row-name": title,
      "data-ph-capture-attribute-row-key": rowKey,
      "data-ph-capture-attribute-row-id": world.id
    };
    $[3] = rowKey;
    $[4] = t2;
    $[5] = title;
    $[6] = world.id;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = world.title;
  const t5 = world.is_ranked;
  const t6 = world.is_ranked ? "-mt-4 -mb-12 pt-4 pb-12" : "-mt-2 -mb-12 pt-2 pb-12";
  let t7;
  if ($[8] !== t6) {
    t7 = cn("no-scrollbar flex w-full flex-1 gap-4 overflow-x-auto pl-4 select-none lg:pl-6", t6);
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t3 || $[11] !== t7 || $[12] !== world) {
    t8 = <Swimlane data-component="world-section" captureAttributes={t3} className="gap-3" title={t4} world={world} cardVariant="viverse" ranking={t5} hideLiked={true} hidePremiumBadge={false} dataRoomIdPrefix="ws" lastCardClassName="mr-4 md:mr-9 lg:mr-6" scrollClassName={t7} />;
    $[10] = t3;
    $[11] = t7;
    $[12] = world;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}
function _temp(ch) {
  return ch.charCodeAt(0) > 127;
}
export default WorldSection;